import { I18n } from '@calendly/i18n'
import { Button } from '@calendly/ui/components/button'
import { AddMiniIcon } from '@calendly/ui/components/icons'

import { appWorkflowTemplatesListUrl } from 'services/workflows/url'

import { maxOwnerWorkflowExceeded } from './util'

const ariaLabel = ({ type, uuid, name }) => {
  if (type === 'user' && uuid === 'me') {
    return I18n.t('publisher.workflows.owner_bar.new_wf_button_personal_aria')
  }

  return I18n.t('publisher.workflows.owner_bar.new_wf_button_other_aria', { name })
}

export const NewWorkflowButton = ({ owner }) => {
  const linkProps = {
    as: 'a',
    href: appWorkflowTemplatesListUrl(owner),
    'aria-label': ariaLabel(owner)
  }

  const additionalProps = maxOwnerWorkflowExceeded(owner) ? { disabled: true } : linkProps

  return (
    <Button
      decoration="secondary-outline"
      size="small"
      aria-label={ariaLabel(owner)}
      {...additionalProps}
    >
      <AddMiniIcon />
      {I18n.t('publisher.workflows.owner_bar.new_workflow_button')}
    </Button>
  )
}
